import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, ArrowRight } from 'lucide-react';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const popularPages = [
    { name: 'Insurance', path: '/insurance', desc: 'Activity-Based NEMT Insurance' },
    { name: 'Payments', path: '/payments', desc: 'Medex Pay Financial Infrastructure' },
    { name: 'Dispatch', path: '/dispatch', desc: 'OVA AI Dispatch Engine' },
    { name: 'Partner With Us', path: '/partner', desc: 'Become a MedexOVA Partner' },
  ];

  return (
    <div className="min-h-screen bg-medex-bg flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl w-full text-center"
      >
        {/* 404 Graphic */}
        <div className="mb-8">
          <div className="text-[150px] font-heading font-bold leading-none">
            <span className="text-neon-cyan">4</span>
            <span className="text-white">0</span>
            <span className="text-neon-purple">4</span>
          </div>
          <div className="h-1 w-32 mx-auto bg-gradient-to-r from-neon-cyan via-neon-purple to-neon-cyan rounded-full" />
        </div>

        <h1 className="text-2xl font-heading font-bold text-white mb-4">
          Page Not Found
        </h1>
        <p className="text-slate-400 mb-8 max-w-md mx-auto">
          Looks like you've taken a wrong turn. The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <button
            onClick={() => navigate(-1)}
            className="btn-secondary flex items-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Go Back</span>
          </button>
          <button
            onClick={() => navigate('/')}
            className="btn-primary flex items-center space-x-2"
          >
            <Home className="w-4 h-4" />
            <span>Home Page</span>
          </button>
        </div>

        {/* Popular Pages */}
        <div className="glass-card p-6">
          <h3 className="text-sm font-mono text-slate-500 uppercase tracking-wider mb-4">
            Popular Pages
          </h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {popularPages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="flex items-center justify-between p-3 bg-white/5 hover:bg-white/10 rounded-lg transition-colors group"
              >
                <div className="text-left">
                  <div className="text-white font-medium">{page.name}</div>
                  <div className="text-xs text-slate-500">{page.desc}</div>
                </div>
                <ArrowRight className="w-4 h-4 text-slate-600 group-hover:text-neon-cyan transition-colors" />
              </Link>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
